<template>
	<div id="Index">
		<div class="my_guardian" >
			<header>{{ $t('other.Guard_him') }}</header>
			<el-row  class="row-bg" justify="space-between" >
			  <el-col :span="8"  v-for="guardian in list" :key="guardian.id">
				  <a href="javascript:void(0);" @click="guardian_checked(guardian.id)" :class="guardian_id == guardian.id ? 'guardian_hover' : 'guardian_hover-a'">
					  <img src="../assets/img/guard.png" />
					  <span class="public-backg-day">{{guardian.day}}{{ $t('other.day')}}{{ $t('other.guardian')}}</span>
					  <span class="public-backg">{{guardian.coin}}桃花</span>
					  <!-- <div class="my_guardian_img_sum">{{guardian.day}}</div> -->
				  </a>
			  </el-col>
			</el-row>
			<div class="true_button">
				<el-button @click="guardian_btn">{{ $t('btn.Confirm_Guardian')}}</el-button>
			</div>
		</div>
	</div>
</template>
<script src="https://unpkg.com/element-ui/lib/index.js"></script>
<script>
  import '@/assets/css/style.css'
	//请求接口组件
	import axios from 'axios'
	export default {
		data() {
			return {
				list:[],
        		guardian_id: ''
			};
		},
		created: function() {
			this.convert();
			document.title = this.$t('title.Guard_him')
		},
		methods: {
			goBack() {
				console.log('go back');
			}, // 导航返回
      guardian_checked(id) {
			  this.guardian_id = id
      },
			convert: function() {
				var uid = this.$route.query.uid;
				var token = this.$route.query.token;
				var touid = this.$route.query.touid;
				axios.get(this.baseUrlApi + "mapi/public/index.php/api/Guardian_api/vue_buy",{ params:{ uid:uid,token:token,touid:touid}}).then(res => {
					console.log(res.data);
					this.list = res.data.data.list;
				})
			},
      guardian_btn() {
        var uid = this.$route.query.uid;
        var token = this.$route.query.token;
        var touid = this.$route.query.touid;
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/Guardian_api/vue_buy_add",{ params:{ uid:uid,token:token,touid:touid, id: this.guardian_id }}).then(res => {
          if(res.data.code == 1){
            this.$message.success(res.data.msg);
          }else{
            this.$message.error(res.data.msg);
          }
        })
      }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/my_guardian.vue